"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9573],{

/***/ 9573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ ServicesFiltersPage; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/next/head.js
var head = __webpack_require__(8038);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ../wif-ui-lib/dist/PageHeader.js
var PageHeader = __webpack_require__(9792);
// EXTERNAL MODULE: ./src/contexts/EmployerSiteContext.tsx
var EmployerSiteContext = __webpack_require__(981);
// EXTERNAL MODULE: ./src/constants/app.ts
var app = __webpack_require__(5884);
// EXTERNAL MODULE: ./src/components/HtmlParser/HtmlParser.tsx + 2 modules
var HtmlParser = __webpack_require__(8940);
// EXTERNAL MODULE: ./src/util/magnolia.ts + 1 modules
var magnolia = __webpack_require__(7581);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(169);
// EXTERNAL MODULE: ../node_modules/next-i18next/dist/esm/index.js + 36 modules
var esm = __webpack_require__(9800);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Filters.js
var Filters = __webpack_require__(700);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Pagination.js
var Pagination = __webpack_require__(3403);
// EXTERNAL MODULE: ../wif-ui-lib/dist/LinkPreview.js
var LinkPreview = __webpack_require__(8041);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Block-9b78bd10.mjs
var Block_9b78bd10 = __webpack_require__(4877);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Image-d6406817.mjs
var Image_d6406817 = __webpack_require__(5905);
// EXTERNAL MODULE: ../node_modules/next/router.js
var router = __webpack_require__(6677);
// EXTERNAL MODULE: ./src/hooks/useImageDataHandler.ts
var useImageDataHandler = __webpack_require__(4847);
;// CONCATENATED MODULE: ./src/magnolia/templates/ServicesFiltersPage/ServicesList.tsx











var ServicesList = function(props) {
    var services = props.services;
    var isPreview = (0,router.useRouter)().isPreview;
    var t = (0,esm/* useTranslation */.$G)().t;
    var imageDataHandler = (0,useImageDataHandler/* default */.Z)();
    var cards = (0,react.useMemo)(function() {
        return services.map(function(service) {
            return mapNodeToLinkPreviewCardProps(service, isPreview, t, imageDataHandler);
        });
    }, [
        services,
        imageDataHandler,
        isPreview,
        t
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkPreview/* LinkPreview */.G, {
            cards: cards,
            hasImages: true,
            hasSaveButton: false,
            backgroundColor: "none",
            topPadding: Block_9b78bd10.B.Padding.SMALL,
            newTab: false
        })
    });
};
function mapNodeToLinkPreviewCardProps(node, isPreview, t, imageDataHandler) {
    var ref, ref1, ref2, ref3;
    var imageData = imageDataHandler(node === null || node === void 0 ? void 0 : node.introductionImage, {
        maxViewport: app/* Viewport.xs */.l_.xs
    });
    var imageProps = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, imageData), {
        altText: node.title,
        styling: Image_d6406817.a.CARD,
        credits: (ref = node.introductionImage) === null || ref === void 0 ? void 0 : (ref1 = ref.metadata) === null || ref1 === void 0 ? void 0 : ref1.rights
    });
    // Determine the link and whether to open in new tab
    var serviceType = ((ref2 = node.type) === null || ref2 === void 0 ? void 0 : ref2.field) || "internal";
    var isExternal = serviceType === "external";
    var externalUrl = (ref3 = node.type) === null || ref3 === void 0 ? void 0 : ref3.externalUrl;
    var link = isExternal && externalUrl ? externalUrl : (0,magnolia/* formatPageLink */.Jd)(node["@path"], isPreview);
    var newTab = isExternal;
    return {
        imageProps: imageProps,
        cardTitle: node.title,
        cardIntroText: node.description,
        link: link,
        linkLabel: node.ctaText || t("navigation.readMore"),
        linkDescription: "",
        hasImages: true,
        hasSaveButton: false,
        newTab: newTab,
        showCTAOnMobile: true,
        badge: node.showWorkInFinlandBadge ? "Work in Finland" : undefined
    };
}

// EXTERNAL MODULE: ./src/hooks/useQuery.ts + 1 modules
var useQuery = __webpack_require__(808);
;// CONCATENATED MODULE: ./src/magnolia/templates/ServicesFiltersPage/useServicesQuery.ts



var useServicesQuery = function(filtersValues) {
    var page = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, limit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 4, displayOnlyChildrenPages = arguments.length > 3 ? arguments[3] : void 0, currentPagePath = arguments.length > 4 ? arguments[4] : void 0;
    var locale = (0,router.useRouter)().locale;
    var offset = (page - 1) * limit;
    var query = (0,react.useMemo)(function() {
        var params = new URLSearchParams(filtersValues);
        params.append("lang", locale || "en");
        params.append("offset", offset.toString());
        params.append("limit", limit.toString());
        if (displayOnlyChildrenPages !== undefined) {
            params.append("displayOnlyChildrenPages", displayOnlyChildrenPages.toString());
        }
        if (currentPagePath) {
            params.append("currentPagePath", currentPagePath);
        }
        return "?" + params.toString();
    }, [
        filtersValues,
        locale,
        offset,
        limit,
        displayOnlyChildrenPages,
        currentPagePath
    ]);
    var ref = (0,useQuery/* default */.Z)("/api/services" + query, {}), data = ref.data, isLoading = ref.isLoading;
    var totalCount = (data === null || data === void 0 ? void 0 : data.total) || 0;
    var pageCount = Math.ceil(totalCount / limit);
    return {
        isLoading: isLoading,
        services: (data === null || data === void 0 ? void 0 : data.results) || [],
        totalCount: totalCount,
        pageCount: pageCount
    };
};

;// CONCATENATED MODULE: ./src/magnolia/templates/ServicesFiltersPage/useServicesListPagination.ts

var useServicesListPagination = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _limit = ref.limit, limit = _limit === void 0 ? 4 : _limit;
    /* const router = useRouter(); */ /* const isUpdatingRef = useRef(false); */ // Simple local state for pagination (no URL sync)
    var ref1 = (0,react.useState)(1), page = ref1[0], setPage = ref1[1];
    /*
  Original URL-based implementation commented out:
  
  // Get page from URL query parameter, default to 1
  const currentPage = useMemo(() => {
    const pageParam = router.query.page;
    if (typeof pageParam === "string") {
      const parsed = parseInt(pageParam, 10);
      return parsed > 0 ? parsed : 1;
    }
    return 1;
  }, [router.query.page]);

  const [page, setPage] = useState(currentPage);
  const pageRef = useRef(page);
  const currentPageRef = useRef(currentPage);
  
  // Update refs when values change
  useEffect(() => {
    pageRef.current = page;
  }, [page]);
  
  useEffect(() => {
    currentPageRef.current = currentPage;
  }, [currentPage]);
  
  // Sync page state with URL parameter only when not in the middle of an update
  useEffect(() => {
    if (!isUpdatingRef.current && currentPage !== pageRef.current) {
      setPage(currentPage);
    }
  }, [currentPage]);

  // Shared function to update page and URL
  const updatePageAndUrl = useCallback(async (newPage: number) => {
    // Set flag to prevent sync during update
    isUpdatingRef.current = true;
    
    // Update local state immediately for UI responsiveness
    setPage(newPage);
    
    // Update URL with new page parameter
    const newQuery = { ...router.query };
    if (newPage === 1) {
      delete newQuery.page; // Remove page parameter for page 1 to keep URL clean
    } else {
      newQuery.page = newPage.toString();
    }
    
    await router.push({
      pathname: router.pathname,
      query: newQuery,
    }, undefined, { shallow: true });
    
    // Reset flag after update is complete
    isUpdatingRef.current = false;
  }, [router]);
  */ var handlePageChange = (0,react.useCallback)(function(newPage) {
        // Simple state update without URL sync
        setPage(newPage);
    }, []);
    var resetToFirstPage = (0,react.useCallback)(function() {
        // Simple state update without URL sync
        setPage(1);
    }, []);
    return {
        page: page,
        limit: limit,
        handlePageChange: handlePageChange,
        resetToFirstPage: resetToFirstPage
    };
};

;// CONCATENATED MODULE: ./src/magnolia/templates/ServicesFiltersPage/ServicesListWithFilters.tsx










var ServicesListWithFilters = function(props) {
    var categories = props.categories, displayOnlyChildrenPages = props.displayOnlyChildrenPages, currentPagePath = props.currentPagePath, wording = props.wording;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    var ref = (0,react.useRef)(null);
    // Use pagination hook
    var ref1 = useServicesListPagination({
        limit: 4
    }), page = ref1.page, limit = ref1.limit, handlePageChange = ref1.handlePageChange, resetToFirstPage = ref1.resetToFirstPage;
    var initialFiltersValues = (0,react.useMemo)(function() {
        return {
            categories: categories.map(function(category) {
                return category["@id"];
            }).join(",")
        };
    }, [
        categories
    ]);
    var ref2 = (0,react.useState)(initialFiltersValues), filtersValues = ref2[0], setFiltersValues = ref2[1];
    var filtersChangeHandler = (0,react.useCallback)(function(values) {
        setFiltersValues((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, values), {
            categories: // no categories selected - behave as all are selected
            !values.categories ? initialFiltersValues.categories : values.categories
        }));
        // Reset to first page when filters change
        resetToFirstPage();
    }, [
        initialFiltersValues,
        resetToFirstPage
    ]);
    // Page change handler with scrolling
    var handlePageChangeWithScroll = (0,react.useCallback)(function(newPage) {
        handlePageChange(newPage);
        // Add a small delay to prevent glitching, then scroll to top of component
        setTimeout(function() {
            if ( true && ref.current) {
                var top = ref.current.offsetTop;
                window.scrollTo({
                    top: top - 80,
                    behavior: "smooth"
                });
            }
        }, 100);
    }, [
        handlePageChange
    ]);
    var ref3 = useServicesQuery((filtersValues === null || filtersValues === void 0 ? void 0 : filtersValues.categories) ? filtersValues : initialFiltersValues, page, limit, displayOnlyChildrenPages, currentPagePath), services = ref3.services, pageCount = ref3.pageCount;
    var categoriesForFilters = (0,react.useMemo)(function() {
        return categories.map(function(category) {
            return {
                value: category["@id"],
                label: category.displayName
            };
        });
    }, [
        categories
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: ref,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "Filters",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Filters/* Filters */.x, {
                    filters: {
                        name: "categories",
                        items: categoriesForFilters,
                        isMulti: true
                    },
                    changeHandler: filtersChangeHandler,
                    wording: wording
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "ServicesList",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ServicesList, {
                    services: services
                })
            }),
            pageCount > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* Pagination */.t, {
                count: pageCount,
                value: page,
                onChange: handlePageChangeWithScroll,
                i18n: {
                    btnNextText: t("pagination.nextPage"),
                    btnPageText: t("pagination.goToPage"),
                    btnPrevText: t("pagination.previousPage")
                }
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/util/SmartEditableArea.tsx
var SmartEditableArea = __webpack_require__(1747);
;// CONCATENATED MODULE: ./src/magnolia/templates/ServicesFiltersPage/ServicesFiltersPage.tsx










function ServicesFiltersPage(props) {
    var title = props.title, metaDescription = props.metaDescription, metadata = props.metadata, main = props.main, isPreview = props.isPreview;
    var heading = props.heading, leadText = props.leadText, categoriesDir = props.categoriesDir, displayOnlyChildrenPages = props.displayOnlyChildrenPages, filtersTitle = props.filtersTitle, filtersClear = props.filtersClear;
    var isEmployerSite = (0,EmployerSiteContext/* default */.Z)().isEmployerSite;
    var categories = categoriesDir && typeof categoriesDir === "object" ? (0,magnolia/* jcrMultiFieldToArray */.FE)(categoriesDir) : [];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: title + app/* META_TITLE_SUFFIX */.A_
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: metaDescription
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeader/* PageHeader */.m, {
                heading: heading,
                leadText: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlParser/* HtmlParser */._, {
                    html: leadText
                }),
                backgroundColor: isEmployerSite ? "lightBlue" : "blue"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ServicesListWithFilters, {
                categories: categories,
                displayOnlyChildrenPages: displayOnlyChildrenPages,
                currentPagePath: (metadata === null || metadata === void 0 ? void 0 : metadata["@path"]) || props["@path"],
                wording: {
                    title: filtersTitle,
                    clearFilters: filtersClear
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartEditableArea/* SmartEditableArea */.Z, {
                isPreview: isPreview,
                slotNode: main
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/magnolia/templates/ServicesFiltersPage/index.ts



/***/ }),

/***/ 3403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ G; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3406);
/* harmony import */ var _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4877);
/* harmony import */ var _Button_c598cb52_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7977);






const w = "pagination", N = "pagination__items", S = "pagination__item", L = "pagination__item--selected", k = "pagination__caption", d = {
  pagination: w,
  paginationItems: N,
  paginationItem: S,
  paginationItemSelected: L,
  paginationCaption: k
};
function A(n) {
  const { value: t = 1, count: e, onChange: o } = n, a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), [i, m] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(P(t, e)), [, p] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useTransition)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => m(P(t, e)), [t, e]);
  const c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (l) => {
      const r = typeof l == "number" ? l : l(i), g = P(r, e);
      g !== i && (m(g), o && p(() => o(g)));
    },
    [i, o, e]
  ), f = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (l) => {
      switch (l.key) {
        case "ArrowRight":
          return a.current?.focus(), c((r) => r + 1);
        case "ArrowLeft":
          return a.current?.focus(), c((r) => r - 1);
      }
    },
    [c]
  ), b = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => D(i, e), [i, e]);
  return { page: i, handlePageChange: c, itemList: b, handleKeyDown: f, containerRef: a };
}
function P(n, t) {
  return Math.max(Math.min(n, t), 1);
}
function D(n, t, e = 1, o = 5) {
  const a = "...";
  return t === 1 ? [e] : t === 2 ? [e, t] : t <= o ? Array(t).fill(0).map((i, m) => m + 1) : n <= 2 ? [e, e + 1, e + 2, a, t] : n >= t - 1 ? [e, a, t - 2, t - 1, t] : [e, a, n, a, t];
}
function G(n) {
  const { i18n: t = {}, count: e, caption: o } = n, {
    btnNextText: a = "Next page",
    btnPrevText: i = "Previous page",
    btnPageText: m = "Go to page"
  } = t, { page: p, handlePageChange: c, itemList: f, handleKeyDown: b, containerRef: l } = A(n);
  return !e || e === 0 ? null : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_1__.B, { topPadding: _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_1__.B.Padding.NONE, bottomPadding: _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_1__.B.Padding.SMALL }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_1__.B.Content, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "div",
    {
      className: d.pagination,
      "data-testid": "pagination",
      onKeyDown: b,
      tabIndex: -1,
      ref: l
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      _Button_c598cb52_mjs__WEBPACK_IMPORTED_MODULE_2__.B.Arrow,
      {
        arrowDirection: "left",
        "data-testid": "pagination-prev",
        "aria-label": i,
        title: i,
        disabled: p === 1,
        onClick: () => c((r) => r - 1)
      }
    ),
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("ul", { className: d.paginationItems, "data-testid": "pagination-items" }, f.map((r, g) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", { key: g }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      R,
      {
        page: r,
        selectedPage: p,
        onSelect: c,
        title: m
      }
    )))),
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      _Button_c598cb52_mjs__WEBPACK_IMPORTED_MODULE_2__.B.Arrow,
      {
        arrowDirection: "right",
        "data-testid": "pagination-next",
        "aria-label": a,
        title: a,
        disabled: p === e,
        onClick: () => c((r) => r + 1)
      }
    )
  ), o && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "p",
    {
      className: d.paginationCaption,
      "data-testid": "pagination-caption"
    },
    o
  )));
}
function R({
  page: n,
  selectedPage: t,
  onSelect: e,
  title: o
}) {
  const a = typeof n == "number", i = a && n === t;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "button",
    {
      type: "button",
      "data-testid": "pagination-item-" + n,
      "aria-current": i ? "page" : void 0,
      "aria-label": a ? `${o} ${n}` : void 0,
      className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_3__.c)(
        d.paginationItem,
        i && d.paginationItemSelected
      ),
      disabled: !a,
      onClick: () => a && e?.(n),
      title: a ? `${o} ${n}` : void 0
    },
    n
  );
}

//# sourceMappingURL=Pagination.js.map


/***/ })

}]);